export default "__VITE_ASSET__G0eUQq4r__"